<script lang="ts">
import SectionEtablissementLogo from '@/generated/sections/SectionEtablissementLogo.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: SectionEtablissementLogo
})

</script>
